// extracted by mini-css-extract-plugin
module.exports = {"FormGroub":"Input_FormGroub__2fHYY","InputEle":"Input_InputEle__38WPV","Invalid":"Input_Invalid__3Nqtt","ErrorMess":"Input_ErrorMess__1VtIR"};